/**
 * 1-lp-analytics.js
 * NIJ-131 — Landing page CTA click tracking via dataLayer
 *
 * Listens for clicks on any element with [data-track-cta] and fires:
 *   dataLayer.push({ event: 'cta_click', cta_label, cta_location, cta_destination })
 *
 * Required data attributes on each tracked element:
 *   data-track-cta        — presence flag (value ignored)
 *   data-cta-label        — human-readable button label (e.g. "Inquire")
 *   data-cta-location     — page slug (e.g. "wall_beds_lp", "transformer_tables_pdp")
 *   data-cta-destination  — destination URL (optional; falls back to element's href)
 *
 * Debug: append ?debug_mode=true to any URL to log events to the console.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-track-cta]');
    if (!btn) return;

    var label = btn.dataset.ctaLabel || '';
    var location = btn.dataset.ctaLocation || '';
    var destination = btn.dataset.ctaDestination || btn.getAttribute('href') || '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cta_click',
      cta_label: label,
      cta_location: location,
      cta_destination: destination
    });

    if (new URLSearchParams(window.location.search).get('debug_mode') === 'true') {
      // eslint-disable-next-line no-console
      console.log('[NIJ-131] cta_click', { cta_label: label, cta_location: location, cta_destination: destination });
    }
  });
})();
